import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from './Logo.jsx';
import {
  LayoutDashboard, Table2, Scale, Map, Users, Layers, Wallet,
  ShieldCheck, HeartHandshake, Target, Globe2, Workflow, IndianRupee, Sliders,
} from 'lucide-react';

export const NAV = [
  { id: 'overview', title: 'Programme Overview', crumb: 'Impact Dashboard', icon: LayoutDashboard },
  { id: 'param', title: 'Parameter Scoring Matrix', crumb: 'OECD Sub-indicators', icon: Table2 },
  { id: 'oecd', title: 'OECD–DAC Analysis', crumb: 'Weighted Framework', icon: Scale },
  { id: 'geo', title: 'State-wise Performance', crumb: 'Geographic Analysis', icon: Map },
  { id: 'partner', title: 'Implementing Partners', crumb: 'Partner Analysis', icon: Users },
  { id: 'region', title: 'Regional & Zonal View', crumb: 'Operational Units', icon: Layers },
  { id: 'budget', title: 'Intervention & Budget', crumb: 'Efficiency Analysis', icon: Wallet },
  { id: 'cost', title: 'Cost of Outcome', crumb: 'CFO Signal · ₹ per Impact', icon: IndianRupee },
  { id: 'simulator', title: 'Programme Simulator', crumb: 'What-If Sandbox', icon: Sliders },
  { id: 'results', title: 'Results Chain', crumb: 'Theory of Change', icon: Workflow },
  { id: 'health', title: 'Data Health & Completeness', crumb: 'Data Quality', icon: ShieldCheck },
  { id: 'reach', title: 'Reach & Impact', crumb: 'Annual Report FY24-25', icon: HeartHandshake },
  { id: 'goals', title: 'Goals & Ambitions', crumb: 'Annual Report FY24-25', icon: Target },
  { id: 'sdg', title: 'SDG Alignment', crumb: 'Annual Report FY24-25', icon: Globe2 },
];

export default function Sidebar() {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    const onResize = () => setCompact(window.innerWidth <= 1024);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <aside className="sidebar" data-testid="sidebar">
      <Logo compact={compact} />

      <div className="section-title" style={{ color: 'rgba(255,255,255,.45)', paddingLeft: 12, marginBottom: 8 }}>
        {compact ? '' : 'Navigation'}
      </div>

      <nav aria-label="Primary" style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {NAV.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.id}
              to={`/${item.id}`}
              className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
              data-testid={`nav-${item.id}`}
              title={item.title}
            >
              <Icon size={16} aria-hidden />
              {!compact && <span>{item.title}</span>}
            </NavLink>
          );
        })}
      </nav>

      {!compact && (
        <div style={{
          marginTop: 20, padding: '10px 12px', color: 'rgba(255,255,255,.55)',
          fontSize: 10.5, lineHeight: 1.5, borderTop: '1px solid rgba(255,255,255,.08)',
        }}>
          Independent OECD–DAC evaluation<br />186 CSR projects · FY 2024-25
        </div>
      )}
    </aside>
  );
}
